import { ReadEmployee } from '@/services/gql/graphql.generated';
import { FC } from 'react';
import TeamMemberActionCard from './TeamMemberActionCard';

interface TeamMemberActionsProps {
  employee: ReadEmployee;
}

export const actionsSectionId = 'actionsSectionId';

export const TeamMemberActions: FC<TeamMemberActionsProps> = ({ employee }) => {
  return (
    <section id={actionsSectionId} className="flex flex-col gap-4">
      <TeamMemberActionCard employee={employee} />
    </section>
  );
};
